import React, { PropTypes } from 'react';
import ParagraphItem from 'tip/components/ParagraphItem';

const NoItem = () => (
  <div className="ui segment">
    <div className="ui info message">
      Aucun paragraphe. Veuillez en ajouter un.
    </div>
  </div>
);

const ParagraphList = ({ paragraphs, ...rest }) => {
  if (paragraphs.length) {
    return (
      <div className="ui segment">
        <div className="ui items">
          {paragraphs.map(paragraph => (
            <ParagraphItem
              key={paragraph.id}
              paragraph={paragraph}
              paragraphCount={paragraphs.length}
              {...rest}
            />
          ))}
        </div>
      </div>
    );
  }

  return <NoItem />;
};

ParagraphList.propTypes = {
  paragraphs: PropTypes.array.isRequired,
};

export default ParagraphList;



// WEBPACK FOOTER //
// ./src/modules/tip/components/ParagraphList.js